const questions = [
  {
    question: "1. Scope",
    answer:
      "1.1 If the vehicle still has a current factory warranty, a sales representative (brand representative) of the manufacturer shall provide the services owed therein. If there is a factory warranty, the beginning of the warranty for new vehicles or vehicles with a current manufacturer's warranty is not the date of the first placing on the market, but the beginning of the warranty in the manufacturer's system or the contractually agreed beginning of the warranty, if any.",
  },
  {
    question: "2. Vehicle characteristics",
    answer:
      "2.1 If the vehicle still has a current factory warranty, a sales representative (brand representative) of the manufacturer shall provide the services owed therein. If there is a factory warranty, the beginning of the warranty for new vehicles or vehicles with a current manufacturer's warranty is not the date of the first placing on the market, but the beginning of the warranty in the manufacturer's system or the contractually agreed beginning of the warranty, if any.",
  },
  {
    question: "3. Warranty / guarantee",
    answer: (
      <>
        <div>
          3.1 The statutory warranty is completely excluded to the extent
          permitted by law.
        </div>
        <br />
        <div>
          3.2 If the vehicle still has a current factory warranty, a sales
          representative (brand representative) of the manufacturer shall
          provide the services owed therein. If there is a factory warranty, the
          beginning of the warranty for new vehicles or vehicles with a current
          manufacturer's warranty is not the date of the first placing on the
          market, but the beginning of the warranty in the manufacturer's system
          or the contractually agreed beginning of the warranty, if any.
        </div>
        <br />
        <div>
          3.3 If there is a special warranty insurance for the vehicle, this
          will take the place of the material warranty according to section 3.1
          and replace it. In this case, the General Terms and Conditions of the
          respective warranty service provider apply.
        </div>
      </>
    ),
  },
  {
    question: "4. Trade-in vehicle",
    answer:
      "4.1 If the vehicle still has a current factory warranty, a sales representative (brand representative) of the manufacturer shall provide the services owed therein. If there is a factory warranty, the beginning of the warranty for new vehicles or vehicles with a current manufacturer's warranty is not the date of the first placing on the market, but the beginning of the warranty in the manufacturer's system or the contractually agreed beginning of the warranty, if any.",
  },
  {
    question: "5. Home Delivery",
    answer:
      "5.1 If the vehicle still has a current factory warranty, a sales representative (brand representative) of the manufacturer shall provide the services owed therein. If there is a factory warranty, the beginning of the warranty for new vehicles or vehicles with a current manufacturer's warranty is not the date of the first placing on the market, but the beginning of the warranty in the manufacturer's system or the contractually agreed beginning of the warranty, if any.",
  },
  {
    question: "6. Right of return",
    answer:
      "6.1 If the vehicle still has a current factory warranty, a sales representative (brand representative) of the manufacturer shall provide the services owed therein. If there is a factory warranty, the beginning of the warranty for new vehicles or vehicles with a current manufacturer's warranty is not the date of the first placing on the market, but the beginning of the warranty in the manufacturer's system or the contractually agreed beginning of the warranty, if any.",
  },
  {
    question: "7. Written form",
    answer:
      "7.1 If the vehicle still has a current factory warranty, a sales representative (brand representative) of the manufacturer shall provide the services owed therein. If there is a factory warranty, the beginning of the warranty for new vehicles or vehicles with a current manufacturer's warranty is not the date of the first placing on the market, but the beginning of the warranty in the manufacturer's system or the contractually agreed beginning of the warranty, if any.",
  },
  {
    question: "8. Applicable law and place of jurisdiction",
    answer:
      "8.1 If the vehicle still has a current factory warranty, a sales representative (brand representative) of the manufacturer shall provide the services owed therein. If there is a factory warranty, the beginning of the warranty for new vehicles or vehicles with a current manufacturer's warranty is not the date of the first placing on the market, but the beginning of the warranty in the manufacturer's system or the contractually agreed beginning of the warranty, if any.",
  },
];

export default questions;
